export const GET_ADMIN_REQUEST = "GET_ADMIN_REQUEST"
export const GET_ADMIN_REQUEST_SUCCESS = "GET_ADMIN_REQUEST_SUCCESS"

export const CREATE_ADMIN_REQUEST = "CREATE_ADMIN_REQUEST"
export const CREATE_ADMIN_REQUEST_SUCCESS = "CREATE_ADMIN_REQUEST_SUCCESS"
export const DELETE_ADMIN_REQUEST = "DELETE_ADMIN_REQUEST"
export const DELETE_ADMIN_REQUEST_SUCCESS = "DELETE_ADMIN_REQUEST_SUCCESS"
